<template xmlns="http://www.w3.org/1999/html">
  <div class="w-full p-10">
    <!-- Filtros de Data -->
    <vs-row
        class="m-0 mb-4"
        vs-align="center"
        vs-justify="center"
        vs-type="flex"
        vs-w="12"
    >
      <vs-col
          vs-align="flex-end"
          vs-justify="flex-end"
          vs-type="flex"
          vs-w="12"
      >
        <!-- Input de Data De -->
        <vs-input
            v-model="filtro.dataDe"
            class="mx-1"
            color="dark"
            label="Data De"
            size="small"
            type="date"
        ></vs-input>

        <!-- Input de Data Até -->
        <vs-input
            v-model="filtro.dataAte"
            class="mx-1"
            color="dark"
            label="Data Até"
            size="small"
            type="date"
        ></vs-input>

        <!-- Botão de Filtrar -->
        <el-button
            class="mx-1"
            plain
            size="small"
            type="primary"
            @click="getAvaliacoes"
        >
          FILTRAR
        </el-button>
      </vs-col>
    </vs-row>

    <!-- Tabela de Avaliações -->
    <vs-row
        class="m-0"
        vs-align="center"
        vs-justify="center"
        vs-type="flex"
        vs-w="12"
    >
      <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
        <div
            id="loading-avalicoes-pco"
            class="cardTable w-full mb-1 vs-con-loading__container"
        >
          <div v-if="avaliacoes.length === 0">
            <div class="pt-20 scroll-avaliacao-pco con-colors">
              <ul class="pt-20">
                <li class="danger-box">
                  <h2 class="p-5" style="color: white !important">
                    Nenhum Técnico
                  </h2>
                </li>
              </ul>
            </div>
          </div>

          <div v-else class="w-full mt-1">
            <VuePerfectScrollbar :settings="settings" class="scroll-avaliacao-pco">
              <vs-table :data="avaliacoes" max-items="100" stripe>
                <template slot="thead">
                  <vs-th id="center" style="width: 5%">Ranking</vs-th>
                  <vs-th style="width: 30%">Técnico</vs-th>
                  <vs-th id="center" style="width: 18%">Total de Pontos</vs-th>
                  <vs-th id="center" style="width: 18%">Total de Premiação</vs-th>
                  <vs-th id="center" style="width: 18%">Horas Totais</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr v-for="(row, index) in data" :key="index" :data="row">
                    <vs-td class="text-center font-semibold">{{ index + 1 }}°</vs-td>
                    <vs-td>{{ row.tecnico }}</vs-td>
                    <vs-td class="text-center">
                      {{ row.pontos ? row.pontos : 0 }}
                    </vs-td>
                    <vs-td class="text-center">
                      {{ $currency(row.bonus) }}
                    </vs-td>
                    <vs-td class="text-center">
                      {{ row.horas ? row.horas : 0 }}
                    </vs-td>
                    <template slot="expand" class="expand-user">
                      <avaliacaoCard :filtro="filtro" :row="row"/>
                    </template>
                  </vs-tr>
                </template>
              </vs-table>
            </VuePerfectScrollbar>
          </div>
        </div>
      </vs-col>

      <!-- Card de Informações de Avaliação -->
      <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
        <vx-card card-background="dark" no-shadow>
          <vs-row>
            <vs-col
                class="py-1"
                vs-align="center"
                vs-justify="flex-start"
                vs-type="flex"
                vs-w="12"
            >
              <!-- Badges de Estatísticas -->
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Colaboradores: </span>
                <span style="color: white;padding-left: 5px"> {{ avaliacoes.length }}</span>
              </Badge>

              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Média Pontos: </span>
                <span
                    style="color: white;padding-left: 5px"> {{
                    avaliacoes.length > 0 ? (avaliacoes.reduce((a, b) => a + (b['pontos'] || 0), 0) / avaliacoes.length).toFixed(2) : 0
                  }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Nota Média: </span>
                <span
                    style="color: white;padding-left: 5px"> {{
                    avaliacoes.length > 0 ? (avaliacoes.reduce((a, b) => a + (b['nota'] || 0), 0) / avaliacoes.length).toFixed(2) : 0
                  }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação Média: </span>
                <span
                    style="color: white;padding-left: 5px"> {{
                    $currency(avaliacoes.reduce((a, b) => a + (b['bonus'] || 0), 0) / avaliacoes.length)
                  }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação Total: </span>
                <span
                    style="color: white;padding-left: 5px"> {{
                    $currency(avaliacoes.reduce((a, b) => a + (b['bonus'] || 0), 0))

                  }}</span>
              </Badge>
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-col>

      <!-- Premiações -->
      <vs-col vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
        <vx-card card-background="#FFCB07" no-shadow>
          <vs-row>
            <vs-col vs-align="center" vs-justify="flex-start" vs-type="flex" vs-w="12">
              <h3 class="font-bold texto-titulo-badge">Regras de Pontuação:</h3>
            </vs-col>
            <vs-col
                style="background-color: #000A12;"
                vs-align="center"
                vs-justify="flex-start"
                vs-type="flex"
                vs-w="12"

            >
              <!-- Badges de Pontuação -->
              <Badge
                  class="mr-2"
                  color="dark"
                  icon="star"
                  size="large"
              >
                <span style="color: violet">5 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ pontos.pontos_5_estrela + ' pts' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">4 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ pontos.pontos_4_estrela + ' pts' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">3 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ pontos.pontos_3_estrela + ' pts' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">2 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ pontos.pontos_2_estrela + ' pts' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">1 estrela: </span>
                <span style="color: white;padding-left: 5px"> {{ pontos.pontos_1_estrela + ' pts' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Não avaliados: </span>
                <span style="color: white;padding-left: 5px"> {{ pontos.pontos_pendente + ' pt' }}</span>
              </Badge>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-w="12">
              <h3 class="font-bold texto-titulo-badge">Regras de Premiação:</h3>
            </vs-col>
            <vs-col style="background-color: #000A12;" vs-w="12">
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação 1 estrela: </span>
                <span style="color: white;padding-left: 5px"> {{ comissoes.comissao_1_estrela + ' R$' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação 2 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ comissoes.comissao_2_estrela + ' R$' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação 3 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ comissoes.comissao_3_estrela + ' R$' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação 4 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ comissoes.comissao_4_estrela + ' R$' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação 5 estrelas: </span>
                <span style="color: white;padding-left: 5px"> {{ comissoes.comissao_5_estrela + ' R$' }}</span>
              </Badge>
              <Badge
                  class="mr-2"
                  color="dark"
                  size="large"
              >
                <span style="color: violet">Premiação não avaliada: </span>
                <span style="color: white;padding-left: 5px"> {{ comissoes.comissao_nao_avaliado + ' R$' }}</span>
              </Badge>
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import avaliacaoCard from "./components/avaliacaoCard";

export default {
  data() {
    return {
      filtro: {dataDe: null, dataAte: null},
      avaliacoes: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
      },
      atividades: [10, 18],
      parametros: [],
      comissoes: {
        comissao_1_estrela: -20.0,
        comissao_2_estrela: -10.0,
        comissao_3_estrela: 1.0,
        comissao_4_estrela: 2.5,
        comissao_5_estrela: 5.0,
        comissao_nao_avaliado: 1.6,
      },
      pontos: {
        pontos_5_estrela: 3,
        pontos_4_estrela: 2,
        pontos_3_estrela: 0,
        pontos_2_estrela: -10,
        pontos_1_estrela: -20,
        pontos_pendente: 1
      }
    };
  },
  methods: {
    async mountData() {
      const date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
          .toISOString()
          .split("T")[0];
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
          .toISOString()
          .split("T")[0];
      this.filtro.dataDe = firstDay;
      this.filtro.dataAte = lastDay;
    },
    async getAvaliacoes() {
      await this.$vs.loading({
        container: "#loading-avalicoes-pco",
        scale: 0.6,
      });
      try {
        this.avaliacoes = await this.$http.post("getAvaliacaoPCO", {
          filtro: this.filtro,
          atividades: this.atividades,
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close(
            "#loading-avalicoes-pco > .con-vs-loading"
        );
      }
    },

  },
  async mounted() {
    await this.mountData();
    await this.getAvaliacoes();
  },
  components: {
    ...components,
    avaliacaoCard,
  },
};
</script>
<style lang="scss">
.texto-titulo-badge {
  color: #1c1c1c;
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 1.5;
  padding: 0.25rem 0;
  text-align: left;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

.scroll-avaliacao-pco {
  height: 73vh !important;
}

thead tr th#center {
  .vs-table-text {
    justify-content: center !important;
  }
}

.cardTable {
  transition-duration: 300ms;
  border-style: solid;
  border-radius: 4px;
  border-color: rgba(211, 211, 211, 0.493);
  border-width: 2px;

  &:hover {
    transition-duration: 555ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(226, 226, 226, 0.25);
  }
}
</style>
